/**
 * author: Ananthapadmanabhan V K
 */
import { useContext } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../constants/api";
import { ScaleLoader } from "react-spinners";
import { ButtonStatusContext } from "../../App";
//  import { notify } from "react-notify-toast";
export const baseURL = BASE_URL;

const incepAxios = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
  },
});

const requestHandler = (request) => {
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  if (error?.response?.status === 401) {
    //Logout on token invalid
    localStorage.clear();
    window.location.href = "/login";
  } else if (error?.config?.suppressErrorToast) {
    // Caller opted out of the default error toast for this one request - an expected failure
    // it already handles itself (e.g. a user correctly denied visibility into a node outside
    // their assignment), not something the user needs to see a raw backend message about.
  } else if (error?.response?.status === 400) {
    toast.error(error?.response?.data?.message ?? error?.response?.data?.title, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
    });
  } else if (error?.response?.status === 403) {
    toast.error("Not Authorized", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else if (error?.response?.status >= 500) {
    toast.error("Server error - Please retry after some time", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
  return Promise.reject(error);
};

incepAxios.interceptors.request.use(
  function (config) {
    if (config.method === "post" || config.method === "put" || config.method === "patch") {
      const btns = document.querySelectorAll(".sbmBtn");
      btns.forEach((btn) => {
        btn.disabled = true;
      });
    }
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
    }
    return requestHandler(config);
  },
  function (error) {
    const btns = document.querySelectorAll(".sbmBtn");
    btns.forEach((btn) => {
      btn.disabled = false;
    });
    return Promise.reject(error);
  }
);
incepAxios.interceptors.response.use(
  function (response) {
    const btns = document.querySelectorAll(".sbmBtn");
    btns.forEach((btn) => {
      btn.disabled = false;
    });
    return responseHandler(response);
  },
  function (error) {
    const btns = document.querySelectorAll(".sbmBtn");
    btns.forEach((btn) => {
      btn.disabled = false;
    });
    return errorHandler(error);
  }
);

export default incepAxios;
